/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../../components//ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { BsFillPencilFill, BsPersonBadgeFill } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import DialogContainer from '../../../../../../../components/shared/Dialog/DialogContainer';
import OrgAppEdit from './OrgAppEdit';
import { FaHistory } from 'react-icons/fa';
import OrgAppHistory from './OrgAppHistory';
import { useNavigate } from 'react-router-dom';

const OrgAppList = () => {
    const [selectedOrgApp, setselectedOrgApp] = useState({});
    const [openEditOrgApp, setopenEditOrgApp] = useState(false);
    const [openHistoryOrgApp, setopenHistoryOrgApp] = useState(false);
    const navigate = useNavigate();
    const orgAppList = useSelector(state => state.orgApp.orgAppList)
    const handleCloseDialog = () => {
        setopenEditOrgApp(false);
        setopenHistoryOrgApp(false);
    }

    return (
        <><TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell label="Organization Name" />
                        <StyledTableCell label="Application Name" />

                        <StyledTableCell label="Details" />
                        <StyledTableCell label=" " />

                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {orgAppList?.Records?.length > 0 && orgAppList.Records.map((row) => (
                        <StyledTableRow key={row.organizationID}>
                            <StyledTableCell label={row.organizationName} />
                            <StyledTableCell label={row.applicationName} />

                            <StyledTableCell   >
                                {row.organizationApplicationDetails.length > 0 ?
                                    <Typography style={{ fontWeight: 'bold' }} color={row.organizationApplicationDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                        {row.organizationApplicationDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                                    </Typography> : "N/A"}
                            </StyledTableCell>

                            <StyledTableCell align="right"  >
                                <Tooltip title={row.applicationName + " Edit"} placement="left" arrow>

                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setselectedOrgApp(row); setopenEditOrgApp(true) }}>
                                        <BsFillPencilFill />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={row.applicationName + " Users"} placement="left" arrow>

                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { navigate('/manage-organizations/applications/users/' + row.organizationApplicationID) }}>
                                        <BsPersonBadgeFill />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={row.applicationName + " History"} placement="left" arrow>

                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setselectedOrgApp(row); setopenHistoryOrgApp(true) }}>
                                        <FaHistory />
                                    </IconButton>
                                </Tooltip>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>


            <DialogContainer
                open={openEditOrgApp}
                handleClose={handleCloseDialog}
            >
                <OrgAppEdit
                    selectedOrgApp={selectedOrgApp}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
            <DialogContainer
                open={openHistoryOrgApp}
                handleClose={handleCloseDialog}
            >
                <OrgAppHistory
                    selectedOrgApp={selectedOrgApp}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}
 
 
export default OrgAppList;
